import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { onMounted, ref } from 'vue';
import { CapSuaChuaService } from '@/core/services/CapSuaChuaService.service';
import { ICapSuaChuaResponseBase } from '@/core/interfaces/ApiResponses';
import { setBreadcrumbLinks } from '@/core/helpers/breadcrumb';
import { useButtonCustom } from '@/core/hooks/use-button-custom';
import { useLoading } from '@/core/hooks/use-loading';
import { useRoute, useRouter } from 'vue-router';
import PageContentBase from '@/layout/_shared/PageContentBase.vue';
import PageContentSection from '@/layout/_shared/PageContentSection.vue';
import ButtonCustom from '@/components/shared/buttons/ButtonCustom.vue';
import Can from '@/components/Can.vue';
import { CAP_SUA_CHUA } from '@/core/constants/permissions';
// import DinhMucCoDinhTable from '@/components/dinh-muc-co-dinh/dinh-muc-co-dinh-table/DinhMucCoDinhTable.vue';
import CapSuaChuaDetail from '@/components/cap-sua-chua/CapSuaChuaDetail.vue';
import { useStore } from 'vuex';
import { swalErrNotification, swalNotification } from '@/core/helpers/utils';


export default /*#__PURE__*/_defineComponent({
  __name: 'Detail',
  setup(__props) {

setBreadcrumbLinks([
  {
    text: 'Cấp sửa chữa',
    routeData: {
      name: 'danh-sach-cap-sua-chua',
    },
  },
  {
    text: 'Chi tiết',
  },
]);

const { ButtonsType, ButtonTypeColors } = useButtonCustom();

const {
  params: { id: idCapSuaChua },
} = useRoute();

const { replace } = useRouter();

const store = useStore();

const capSuaChuaDetail = ref<ICapSuaChuaResponseBase | null>(null);

const { startLoading, endLoading } = useLoading();

document.title = 'Chi tiết cấp sửa chữa - Đường sắt Hà Nội';

const fetchData = async () => {
  await startLoading();

  const {
    data: { data },
  } = await CapSuaChuaService.get(+idCapSuaChua);

  capSuaChuaDetail.value = data;
  document.title = `${data.ten_cap_sc} - Cấp sửa chữa - Đường sắt Hà Nội`;

  await endLoading();
};

const onDeleteButtonClick = () => {
  if (!capSuaChuaDetail.value) {
    return;
  }

  store.commit('ConfirmationDialogModule/setDialog', {
    message: `Bạn có chắc chắn muốn xoá cấp sửa chữa ${capSuaChuaDetail.value.ten_cap_sc}?`,
    onConfirm: async () => {
      store.commit('ConfirmationDialogModule/closeDialog');
      await startLoading();

      try {
        await CapSuaChuaService.delete(capSuaChuaDetail.value?.id ?? +idCapSuaChua);
        await endLoading();
        await swalNotification('Xoá cấp sửa chữa thành công');

        await replace({
          name: 'danh-sach-cap-sua-chua',
        });
      } catch (e) {
        await endLoading();
        await swalErrNotification(e, 'Không thể xoá cấp sửa chữa này');
      }
    },
  });
};

onMounted(() => {
  fetchData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PageContentBase, { plain: "" }, {
    default: _withCtx(() => [
      _createVNode(PageContentSection, { "always-expanded": true }, {
        actions: _withCtx(() => [
          _createVNode(Can, {
            all: [_unref(CAP_SUA_CHUA).SUA]
          }, {
            default: _withCtx(() => [
              _createVNode(ButtonCustom, {
                "button-type": _unref(ButtonsType).EDIT,
                "color-type": _unref(ButtonTypeColors).SUCCESS,
                "tooltip-message": "Chỉnh sửa",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (
            _ctx.$router.push({
              name: 'chinh-sua-cap-sua-chua',
              params: { id: _unref(idCapSuaChua) },
            })
          ))
              }, null, 8, ["button-type", "color-type"])
            ]),
            _: 1
          }, 8, ["all"]),
          _createVNode(Can, {
            all: [_unref(CAP_SUA_CHUA).XOA]
          }, {
            default: _withCtx(() => [
              _createVNode(ButtonCustom, {
                "button-type": _unref(ButtonsType).TRASH,
                "color-type": _unref(ButtonTypeColors).DANGER,
                "tooltip-message": "Xoá",
                onClick: onDeleteButtonClick
              }, null, 8, ["button-type", "color-type"])
            ]),
            _: 1
          }, 8, ["all"])
        ]),
        default: _withCtx(() => [
          (capSuaChuaDetail.value)
            ? (_openBlock(), _createBlock(CapSuaChuaDetail, {
                key: 0,
                "cap-sua-chua-detail": capSuaChuaDetail.value
              }, null, 8, ["cap-sua-chua-detail"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})